module.exports = __webpack_public_path__ + "static/media/bodino-poure-kolokuthas.69913d87.jpg";